import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { g } from "@/lib/api";
import { useI18n } from "@/i18n";
import { Sparkles, ArrowRight, AlertTriangle } from "lucide-react";

/** Striscia della prova: giorni rimanenti oppure, a prova scaduta, avviso del passaggio al Gratuito. */
export const TrialBanner = ({ owner }) => {
  const { t, setLang } = useI18n();
  const navigate = useNavigate();
  const [info, setInfo] = useState(null);

  useEffect(() => {
    g("/tenant/trial-status")
      .then((d) => {
        setInfo(d);
        // La lingua della demo si applica solo al primo ingresso: dopo vince la scelta dell'utente.
        if (d?.trial && d.lang && !localStorage.getItem("rh_lang")) setLang(d.lang);
      })
      .catch(() => setInfo(null));
  }, [setLang]);

  if (!info?.trial) return null;

  if (info.expired) {
    return (
      <div className="flex flex-wrap items-center gap-x-3 gap-y-1 bg-amber-600 px-4 py-2 text-white" data-testid="trial-expired-strip">
        <AlertTriangle className="h-4 w-4 shrink-0" />
        <span className="text-sm font-bold" data-testid="trial-expired-tag">{t("trial.over")}</span>
        <span className="text-xs text-amber-50">{t("trial.overKeep", { n: info.days_to_purge ?? 0 })}</span>
        {owner && (
          <button
            onClick={() => navigate("/abbonamento")}
            data-testid="trial-reactivate-btn"
            className="ml-auto flex items-center gap-1 rounded-full bg-white/20 px-3 py-1 text-xs font-bold transition-colors hover:bg-white/30"
          >
            {t("trial.reactivate")} <ArrowRight className="h-3 w-3" />
          </button>
        )}
      </div>
    );
  }

  return (
    <div className="flex flex-wrap items-center gap-x-3 gap-y-1 bg-emerald-600 px-4 py-2 text-white" data-testid="trial-strip">
      <Sparkles className="h-4 w-4 shrink-0" />
      <span className="text-sm font-bold" data-testid="trial-days-left">{t("trial.left", { n: info.days_left })}</span>
      <span className="text-xs text-emerald-50">{t("trial.keep")}</span>
      {owner && (
        <button
          onClick={() => navigate("/abbonamento")}
          data-testid="trial-activate-btn"
          className="ml-auto flex items-center gap-1 rounded-full bg-white/15 px-3 py-1 text-xs font-bold transition-colors hover:bg-white/25"
        >
          {t("trial.activate")} <ArrowRight className="h-3 w-3" />
        </button>
      )}
    </div>
  );
};
